/**
 * Variant Cards Handler
 * Manages the selection of variant cards and form submission
 */

class VariantCardsHandler {
    constructor(container) {
        this.container = container;
        this.productForm = document.querySelector('form[id*="product-form"][data-type="add-to-cart-form"]');
        this.installmentForm = document.querySelector('form[id*="product-form-installment"]');
        this.variantInputs = container.querySelectorAll('.variant-card__input');
        // Extrair product ID do data-product-id ou do ID do elemento
        this.productId = container.dataset.productId || container.querySelector('[id*="product-option"]')?.id.match(/\d+$/)?.[0];
        console.log('[VariantCardsHandler] ProductId extraído:', this.productId);
        this.variantData = this.getVariantData();
        
        this.init();
    }

    init() {
        if (!this.variantInputs.length) return;

        // Calcula preço por unidade para todas as variantes
        this.calculateUnitPrices();

        // Adiciona event listeners aos inputs de variantes
        this.variantInputs.forEach(input => {
            input.addEventListener('change', (e) => {
                this.onVariantChange(e.target);
            });
        });
    }

    calculateUnitPrices() {
        const variantCards = this.container.querySelectorAll('.variant-card');
        
        variantCards.forEach(card => {
            const unitPriceSpan = card.querySelector('.variant-card__unit-price');
            if (!unitPriceSpan) return;

            const title = unitPriceSpan.dataset.variantTitle || '';
            const price = parseInt(unitPriceSpan.dataset.price) || 0;

            // Extrai quantidade do título (ex: "3 unidades" -> 3)
            const quantityMatch = title.match(/(\d+)\s+unidade/i);
            const quantity = quantityMatch ? parseInt(quantityMatch[1]) : 1;

            // Só mostra preço por unidade se quantidade > 1
            if (quantity > 1) {
                const unitPrice = price / quantity;
                const formattedUnitPrice = this.formatPrice(unitPrice);
                unitPriceSpan.textContent = `${formattedUnitPrice}/cada`;
            } else {
                unitPriceSpan.textContent = '';
            }
        });
    }

    getVariantData() {
        const jsonScript = this.container.querySelector('script[type="application/json"]');
        if (jsonScript) {
            try {
                return JSON.parse(jsonScript.textContent);
            } catch (e) {
                console.error('Erro ao parsear variant data:', e);
                return [];
            }
        }
        return [];
    }

    onVariantChange(selectedInput) {
        const variantId = selectedInput.value;
        console.log('[VariantCardsHandler] Variant selecionada:', variantId);
        
        // Remove a classe selected de todos os cards
        this.container.querySelectorAll('.variant-card').forEach(card => {
            card.classList.remove('variant-card--selected');
        });
        
        // Adiciona a classe selected ao card selecionado
        const selectedCard = selectedInput.closest('.variant-card');
        if (selectedCard) {
            selectedCard.classList.add('variant-card--selected');
        }
        
        // Encontra os dados da variant selecionada
        const selectedVariant = this.variantData.find(v => v.id.toString() === variantId);
        console.log('[VariantCardsHandler] Dados da variant:', selectedVariant);
        
        // Atualiza o valor de id no form ATC
        if (this.productForm) {
            const idInput = this.productForm.querySelector('input[name="id"]');
            if (idInput) {
                idInput.value = variantId;
                console.log('[VariantCardsHandler] Form ATC atualizado com ID:', variantId);
            }
        } else {
            console.log('[VariantCardsHandler] AVISO: Form ATC não encontrado');
        }

        // Atualiza o valor de id no form de parcelamento
        if (this.installmentForm) {
            const idInput = this.installmentForm.querySelector('input[name="id"]');
            if (idInput) {
                idInput.value = variantId;
                console.log('[VariantCardsHandler] Form parcelamento atualizado com ID:', variantId);
            }
        }

        // Atualiza o preço do produto
        if (selectedVariant && this.productId) {
            console.log('[VariantCardsHandler] Atualizando preço para product ID:', this.productId);
            this.updateProductPrice(selectedVariant);
        } else {
            console.log('[VariantCardsHandler] AVISO: Variant ou productId não encontrados', { selectedVariant, productId: this.productId });
        }

        // Dispara evento customizado para outros scripts
        const event = new CustomEvent('variantSelected', {
            detail: {
                variantId: variantId,
                variant: selectedVariant,
                variantElement: selectedInput.closest('.variant-card')
            }
        });
        this.container.dispatchEvent(event);
    }

    updateProductPrice(variant) {
        const priceContainer = document.querySelector(`#product-price-${this.productId}`);
        console.log('[VariantCardsHandler] Buscando container de preço:', `#product-price-${this.productId}`);
        console.log('[VariantCardsHandler] Container encontrado:', !!priceContainer);
        
        if (!priceContainer) {
            console.log('[VariantCardsHandler] ERRO: Container de preço não encontrado');
            return;
        }

        const price = variant.price;
        const comparePrice = variant.compare_at_price;
        console.log('[VariantCardsHandler] Preços:', { price, comparePrice });

        // Atualiza os data attributes
        const comparePriceEl = priceContainer.querySelector('[data-compare]');
        const lastPriceEl = priceContainer.querySelector('[data-last]');
        
        console.log('[VariantCardsHandler] Elementos encontrados:', { comparePriceEl: !!comparePriceEl, lastPriceEl: !!lastPriceEl });

        if (comparePriceEl) {
            comparePriceEl.setAttribute('data-compare', comparePrice);
            console.log('[VariantCardsHandler] data-compare atualizado para:', comparePrice);
        }
        if (lastPriceEl) {
            lastPriceEl.setAttribute('data-last', price);
            console.log('[VariantCardsHandler] data-last atualizado para:', price);
        }

        // Atualiza os textos dos preços
        const priceTexts = priceContainer.querySelectorAll('.price-item');
        console.log('[VariantCardsHandler] Elementos de preço encontrados:', priceTexts.length);
        
        priceTexts.forEach((el, idx) => {
            const oldText = el.textContent;
            if (el.classList.contains('price-item--regular')) {
                el.textContent = this.formatPrice(comparePrice || price);
                console.log('[VariantCardsHandler] Regular price atualizado:', oldText, '->', el.textContent);
            } else if (el.classList.contains('price-item--sale')) {
                el.textContent = this.formatPrice(price);
                console.log('[VariantCardsHandler] Sale price atualizado:', oldText, '->', el.textContent);
            }
        });
    }

    formatPrice(cents) {
        // Arredonda antes de separar: precos por unidade dividem centavos (ex.: 9999/4 = 2499.75)
        // e sem isto o resto virava fracionario, imprimindo "R$ 24,99.75".
        const total = Math.round(cents);
        const reais = Math.floor(total / 100);
        const centavos = total % 100;
        return `R$ ${reais.toLocaleString('pt-BR')},${centavos.toString().padStart(2, '0')}`;
    }

    getSelectedVariantId() {
        const selectedInput = this.container.querySelector('.variant-card__input:checked');
        return selectedInput ? selectedInput.value : null;
    }
}

// Inicializa quando o DOM está pronto
document.addEventListener('DOMContentLoaded', () => {
    const variantContainers = document.querySelectorAll('.productView-variants');
    
    variantContainers.forEach(container => {
        if (!container.dataset.variantHandlerInitialized) {
            new VariantCardsHandler(container);
            container.dataset.variantHandlerInitialized = 'true';
        }
    });
});

// Também inicializa se o script carregar antes do DOMContentLoaded
if (document.readyState === 'interactive' || document.readyState === 'complete') {
    const variantContainers = document.querySelectorAll('.productView-variants');
    
    variantContainers.forEach(container => {
        if (!container.dataset.variantHandlerInitialized) {
            new VariantCardsHandler(container);
            container.dataset.variantHandlerInitialized = 'true';
        }
    });
}
